import { render, staticRenderFns } from "./SendersDomainList.vue?vue&type=template&id=85242e54&scoped=true&"
import script from "./SendersDomainList.vue?vue&type=script&lang=js&"
export * from "./SendersDomainList.vue?vue&type=script&lang=js&"
import style0 from "./SendersDomainList.vue?vue&type=style&index=0&id=85242e54&scoped=true&lang=scss&"
import style1 from "./SendersDomainList.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "85242e54",
  null
  
)

export default component.exports